import React, { useEffect } from 'react'

import { ClerkProvider, useUser } from '@clerk/clerk-react'

import { createAuth } from '@cedarjs/auth-clerk-web'

import { Environments, EnvVariables, isProduction, PublicApiChatBotUrl } from './constants'

export const { AuthProvider: ClerkRwAuthProvider, useAuth } = createAuth()

const ClerkStatusUpdater = () => {
  const { isSignedIn, user, isLoaded } = useUser()
  const { reauthenticate } = useAuth()

  useEffect(() => {
    if (isLoaded) {
      void reauthenticate()
    }
  }, [isSignedIn, user, reauthenticate, isLoaded])

  return null
}

type Props = {
  children: React.ReactNode
}
export const AuthProvider = ({ children }: Props) => {
  const getSatelliteOptions = () => {
    if (isProduction() && window.location.href.startsWith(PublicApiChatBotUrl)) {
      return {
        isSatellite: true,
        domain: (url: URL) => url.host,
        signInUrl: 'https://app.govwell.com/sign-in',
        signUpUrl: 'https://app.govwell.com/sign-up',
      }
    }
    if (EnvVariables.Environment === Environments.ProductionMirror) {
      return {
        isSatellite: true,
        domain: (url: URL) => url.host,
        signInUrl: 'https://app.govwell.com/sign-in',
        signUpUrl: 'https://app.govwell.com/sign-up',
      }
    }
    return {}
  }
  return (
    <ClerkRwAuthProvider>
      <ClerkProvider
        publishableKey={EnvVariables.ClerkPublishableKey}
        localization={{
          formFieldLabel__phoneNumber: 'Mobile Phone Number',
          formFieldInputPlaceholder__phoneNumber: 'Enter your mobile phone number',
        }}
        {...getSatelliteOptions()}
      >
        {children}
        <ClerkStatusUpdater />
      </ClerkProvider>
    </ClerkRwAuthProvider>
  )
}
